// Wiring + fachada do domínio Config (adapters Supabase → services).
// Exporta as mesmas funções (nomes) dos antigos repositories/services de
// config: configRepository, pipelinesRepository, usersRepository,
// workspaceConfigService, filterOptionsService, tagService,
// pipelineMembersService.

import {
  configService,
  pipelinesRepo,
  usersRepo,
  workspaceConfigService,
  tagService,
  pipelineMembersService,
  filterOptionsService,
} from './core';

// ─── configRepository ───────────────────────────────────────────
export const getConfigValue           = configService.getConfigValue;
export const setConfigValue           = configService.setConfigValue;
export const getCommissionRates       = configService.getCommissionRates;
export const setCommissionRates       = configService.setCommissionRates;
export const getWorkspaceOrigins      = configService.getWorkspaceOrigins;
export const setWorkspaceOrigins      = configService.setWorkspaceOrigins;
export const getWorkspaceOriginCounts = configService.getWorkspaceOriginCounts;

// ─── pipelinesRepository (data-access puro via porta) ───────────
export const listPipelineIds   = pipelinesRepo.listPipelineIds;
export const listFunnels       = pipelinesRepo.listFunnels;
export const listPipelinesRich = pipelinesRepo.listPipelinesRich;

// ─── usersRepository (data-access puro via porta) ───────────────
export const listUsersByRole   = usersRepo.listUsersByRole;
export const getProfilesByIds  = usersRepo.getProfilesByIds;
export const updateProfileName = usersRepo.updateProfileName;

// ─── workspaceConfigService ─────────────────────────────────────
export const listPipelinesWithLossReasons = workspaceConfigService.listPipelinesWithLossReasons;
export const setPipelineLossReasons       = workspaceConfigService.setPipelineLossReasons;

// ─── filterOptionsService ───────────────────────────────────────
export const loadFilterOptions = filterOptionsService.loadFilterOptions;

// ─── tagService ─────────────────────────────────────────────────
export const listTags         = tagService.listTags;
export const createTag           = tagService.createTag;
export const updateTag       = tagService.updateTag;
export const addTagToLead = tagService.addTagToLead;
export const removeTagFromLead   = tagService.removeTagFromLead;
export const listLeadTags   = tagService.listLeadTags;

// ─── pipelineMembersService ─────────────────────────────────────
export const listPipelineMembers        = pipelineMembersService.listPipelineMembers;
export const listProfilesByPipelineRole = pipelineMembersService.listProfilesByPipelineRole;
export const upsertPipelineMember        = pipelineMembersService.upsertPipelineMember;
export const setPipelineMemberActive     = pipelineMembersService.setPipelineMemberActive;
export const deletePipelineMember        = pipelineMembersService.deletePipelineMember;

// ─── Tipos (nomes originais) ────────────────────────────────────
export type { PipelineRole, PipelineIdsParams, FunnelSummary, PipelineRich } from '@modules/config';
export type { UserLite, ProfileLite } from '@modules/config';
export type { PipelineLossReasonsInfo } from '@modules/config';
export type { FilterOptionItem, FilterOptionsResult } from '@modules/config';
export type { Tag, LeadTag } from '@modules/config';
export type {
  PipelineMemberProfile,
  PipelineMemberEntry,
  ListPipelineMembersOpts,
  UpsertPipelineMemberParams,
} from '@modules/config';
